import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import React from "react";

interface CustomGroupDialog {
  title?: string | JSX.Element;
  children: JSX.Element;
  isOpen: boolean;
  onClose: () => void;
}

const CustomGroupDialog = ({
  children,
  title,
  isOpen,
  onClose,
}: CustomGroupDialog) => {
  return (
    <Dialog
      open={isOpen}
      onClose={(event, reason) => {
        onClose();
      }}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{children}</DialogContent>
    </Dialog>
  );
};

export default CustomGroupDialog;
